import { DsIcon } from '@ice-web-app/designSystem';
import { loadModuleNamespace } from '@ice-web-app/shared-i18n';
import { useGlobalStore, useSidebarStore } from '@ice-web-app/shared-store';
import { getCurrentEcosystemBasePath } from '@ice-web-app/shared-utils';
import { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { satV3AR, satV3DE, satV3EN } from '../locales';
import { ZoneRoutes } from '../routes/ZoneRoutes';
import { routes } from '../routes/routes';

export const SatV3Zone: FC = () => {
  const { setMenuItems, setEntityMenuItems, setShowEntityMenu, setBackPath } = useSidebarStore();
  const { setShowMainSidebar } = useGlobalStore();
  const showMainSidebar = localStorage.getItem('showMainSidebar') === 'true';
  const location = useLocation();

  useEffect(() => {
    setShowMainSidebar(showMainSidebar);
  }, [showMainSidebar]);

  // Check if we are on an entity route
  useEffect(() => {
    const isEntityRoute = location.pathname.includes('/entity/');
    const entityIdMatch = location.pathname.match(/\/entity\/([^/]+)\//);
    const entityId = entityIdMatch ? entityIdMatch[1] : null;

    if (isEntityRoute && entityId) {
      // Show entity menu
      setShowEntityMenu(true);
      setEntityMenuItems([]);
    } else {
      // Show regular menu
      setShowEntityMenu(false);
      setEntityMenuItems([]);
    }
  }, [location.pathname]);

  useEffect(() => {
    setBackPath(getCurrentEcosystemBasePath() || '/');

    setMenuItems([
      {
        title: 'Dashboard',
        icon: <DsIcon icon={'ADD_PHOTO'} />,
        path: routes.dashboard,
      },
      {
        title: 'School Setup',
        icon: <DsIcon icon={'SCHOOL_STAFF'} />,
        path: routes.schoolSetup.structure,
        submenu: [
          {
            title: 'School Structure',
            path: routes.schoolSetup.structure,
          },
          {
            title: 'School Day',
            path: routes.schoolSetup.day,
          },
          {
            title: 'Academic Calendar',
            path: routes.schoolSetup.calendar,
          },
        ],
      },
      {
        title: 'People',
        icon: <DsIcon icon={'PROFILE'} />,
        path: routes.people.teachers,
        submenu: [
          { title: 'Teachers', path: routes.people.teachers },
          { title: 'Students', path: routes.people.students },
          { title: 'Staff Roles', path: routes.people.roles },
        ],
      },
      {
        title: 'Curriculum',
        icon: <DsIcon icon={'ADD_REACTION'} />,
        path: routes.curriculum.subjects,
        submenu: [
          { title: 'Subjects', path: routes.curriculum.subjects },
          { title: 'Curriculum Plans', path: routes.curriculum.plans },
          { title: 'Groupings', path: routes.curriculum.groupings },
        ],
      },
      {
        title: 'Rules',
        icon: <DsIcon icon={'ALERT_ERROR'} />,
        path: routes.rules.hard,
        submenu: [
          { title: 'Hard Rules', path: routes.rules.hard },
          { title: 'Soft Rules', path: routes.rules.soft },
          {
            title: 'Preferences',
            path: routes.rules.preferences,
          },
          {
            title: 'Teacher Preferences',
            path: routes.rules.teacherPreferences,
          },
          { title: 'Automation Profiles', path: routes.rules.profiles },
        ],
      },
      {
        title: 'Generator',
        icon: <DsIcon icon={'ALERT_ERROR'} />,
        path: routes.generator.generate,
        submenu: [
          { title: 'Generate Timetable', path: routes.generator.generate },
          { title: 'Generation History', path: routes.generator.history },
          { title: 'Automation Settings', path: routes.generator.settings },
        ],
      },
      {
        title: 'Timetable',
        icon: <DsIcon icon={'ALERT_WARNING'} />,
        path: routes.timetable.view,
        submenu: [
          { title: 'View Timetable', path: routes.timetable.view },
          { title: 'Edit Timetable', path: routes.timetable.edit },
          { title: 'Conflicts', path: routes.timetable.conflicts },
        ],
      },
      {
        title: 'Simulations',
        icon: <DsIcon icon={'ALERT_TRIANGLE'} />,
        path: routes.simulations,
      },
      {
        title: 'Versions',
        icon: <DsIcon icon={'ALIGN_LEFT'} />,
        path: routes.versions.history,
        submenu: [
          { title: 'Version History', path: routes.versions.history },
          { title: 'Finalization', path: routes.versions.finalize },
        ],
      },
      {
        title: 'Export',
        icon: <DsIcon icon={'ATTACHMENT'} />,
        path: routes.export.timetables,
        submenu: [
          { title: 'Export Timetables', path: routes.export.timetables },
          { title: 'Portal Preview', path: routes.export.preview },
        ],
      },
    ]);

    return () => {
      setBackPath('');
    };
  }, []);

  useEffect(() => {
    loadModuleNamespace('satV3Zone', [
      { jsonFile: satV3AR, lang: 'ar' },
      { jsonFile: satV3DE, lang: 'de' },
      { jsonFile: satV3EN, lang: 'en' },
    ]);
  }, []);

  return <ZoneRoutes />;
};
export default SatV3Zone;
